import { App } from '@capacitor/app';

// Zentraler Event-Bus für Zurückbutton-Events
const backButtonListeners = [];

// Referenz auf den Haupt-Back-Button-Handler
let mainBackButtonHandler = null;

// Höchste Priorität: 100, Niedrigste: 0
// Standard-Handler wird immer mit niedrigster Priorität (0) ausgeführt
export const BackButtonService = {
  // Event-Handler registrieren (z.B. für Modals/Sidebars)
  addListener(handler, priority = 50) {
    const listener = { handler, priority };
    backButtonListeners.push(listener);
    // Sortieren nach Priorität (höchste zuerst)
    backButtonListeners.sort((a, b) => b.priority - a.priority);
    
    // console.log('Handler hinzugefügt, aktuelle Anzahl:', backButtonListeners.length);
    
    // Handler zum Entfernen des Listeners zurückgeben
    return () => {
      const index = backButtonListeners.findIndex(l => l === listener);
      if (index > -1) {
        backButtonListeners.splice(index, 1);
        // console.log('Handler entfernt, aktuelle Anzahl:', backButtonListeners.length);
      }
    };
  },
  
  // Alle registrierten Handler abrufen
  getListeners() {
    return [...backButtonListeners];
  },
  
  // Entfernt alle Handler mit einer bestimmten Priorität oder höher (außer dem Standard-Handler)
  removeListenersWithPriority(minPriority = 10) {
    const indicesToRemove = [];
    backButtonListeners.forEach((listener, index) => {
      if (listener.priority >= minPriority) {
        indicesToRemove.push(index);
      }
    });
    
    // Von hinten nach vorne entfernen, um die Indizes nicht zu verschieben
    for (let i = indicesToRemove.length - 1; i >= 0; i--) {
      backButtonListeners.splice(indicesToRemove[i], 1);
    }
    
    // console.log('Handler mit Priorität >= ' + minPriority + ' entfernt, aktuelle Anzahl:', backButtonListeners.length);
  },
  
  // Aktiviert das Zurückbutton-Listening nach einem Modal-Close, um sicherzustellen,
  // dass der nächste Zurückbutton-Klick das gewünschte Verhalten zeigt
  refreshBackButton() {
    if (process.client) {
      // Entferne alle möglichen "vergessenen" Handler höherer Priorität
      this.removeListenersWithPriority(10); // Entferne alle mit Priorität 10+
      
      // console.log('BackButtonService: Refresh ausgelöst, Handler-Anzahl nach Bereinigung:', backButtonListeners.length);
    }
  },
  
  // Debug-Funktion, um Informationen über den aktuellen Zustand zu erhalten
  debug() {
    return {
      listenersCount: backButtonListeners.length,
      listeners: backButtonListeners.map(l => l.priority),
      canGoBack: window.history.length > 1
    };
  }
};

export default ({ app, store, redirect }) => {
  // Nur ausführen, wenn die App im Browser läuft
  if (process.client) {
    // App initialisieren nach dem Laden der Seite
    window.onNuxtReady(() => {
      // Hardware-Zurückbutton-Handler für Android
      const handleBackButton = ({ canGoBack }) => {
        console.log('Zurückbutton wurde gedrückt, canGoBack:', canGoBack, 'Anzahl Handler:', backButtonListeners.length);
        
        // Durchlaufe alle Handler nach Priorität
        let eventHandled = false;
        
        // Eine Kopie der Handler-Liste erstellen, um Probleme zu vermeiden, falls sich diese während
        // des Durchlaufs ändert (z.B. wenn ein Handler sich selbst entfernt)
        const currentListeners = BackButtonService.getListeners();
        
        for (const listener of currentListeners) {
          try {
            const handled = listener.handler(canGoBack);
            if (handled) {
              // Wenn ein Handler das Event verarbeitet hat, merken und abbrechen
              eventHandled = true;
              console.log('Event verarbeitet durch Handler mit Priorität:', listener.priority);
              break;
            }
          } catch (error) {
            console.error('Fehler im Zurückbutton-Handler:', error);
          }
        }
        
        // Wenn kein Handler das Event verarbeitet hat und wir zurücknavigieren können
        if (!eventHandled && canGoBack) {
          console.log('Keine Handler haben das Event verarbeitet, führe history.back() aus');
          window.history.back();
          return;
        }
        
        // Wenn weder Handler noch history.back funktionieren,
        // machen wir nichts, damit die App nicht geschlossen wird
      };
      
      // Zurückbutton-Handler registrieren und Referenz speichern
      mainBackButtonHandler = handleBackButton;
      const backButtonListener = App.addListener('backButton', handleBackButton);
      
      // Standard-Handler für Browser-Navigation registrieren (niedrigste Priorität)
      // Dieser Handler wird nur ausgeführt, wenn keine Sidebar/Modal geöffnet ist
      BackButtonService.addListener((canGoBack) => {
        // Standardverhalten: Nichts tun, damit der Fallback-Code oben ausgeführt wird
        // und window.history.back() automatisch aufgerufen wird
        console.log('Standard-Handler (Priorität 0) wird aufgerufen');
        return false; // Event wurde nicht behandelt
      }, 0);
    });
  }
}; 
